import ImgComponent from './containers/imgComponent'

export { default as ImgLayout } from './components/imgLayout' 

export default ImgComponent